module.exports = __webpack_public_path__ + "img/KM.c302f897.svg";